import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M14.874 15.582a6 6 0 1 1 .707-.707l3.273 3.271a.5.5 0 0 1-.708.708zM16 11a5 5 0 1 0-10 0 5 5 0 0 0 10 0z"
}), 'Search');
//# sourceMappingURL=index.js.map